import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=2e123a1f&"
import script from "./Sample.vue?vue&type=script&lang=ts&"
export * from "./Sample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports